import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig } from './Service/authConfig';

const msalInstance = new PublicClientApplication(msalConfig);

async function startApp() {
  try {
    await msalInstance.initialize();

    const response = await msalInstance.handleRedirectPromise();
    if (response) {
      msalInstance.setActiveAccount(response.account);
    } else {
      const accounts = msalInstance.getAllAccounts();
      if (accounts.length > 0) {
        msalInstance.setActiveAccount(accounts[0]);
      }
    }

  } catch (e) {
    console.error("MSAL initialization failed", e);
  }

const rootElement = document.getElementById("root");
if (rootElement) {
  ReactDOM.createRoot(rootElement).render(
    <MsalProvider instance={msalInstance}>
      <App />
    </MsalProvider>
  );
}
}

startApp();
